// Warn-tinted banner shown at the top of the drawer body when a russia
// request is in RETURN status (#944). Mirrors china's banner shape but
// without a reason body — russia's wire payload does not carry the
// return reason today (the schema is action-only); the banner therefore
// signals the status without freeform text. Surfacing the reason from
// the audit ledger is a follow-up.

import { useTranslation } from 'react-i18next';
import { RequestStatus, type RussiaRequest } from '@magimp/shared';
import { Icon } from '../../../ui/index.js';

export function RussiaRequestDrawerReturnBanner({ request }: { request: RussiaRequest }) {
  const { t } = useTranslation('russiaRequests');
  if (request.status !== RequestStatus.RETURN) return null;
  return (
    <div
      data-testid="russia-request-drawer-return-banner"
      style={{
        margin: '12px 18px 0',
        padding: '12px 14px',
        background: 'var(--status-warn-bg)',
        borderRadius: 'var(--r-2)',
        display: 'flex',
        gap: 10,
        flex: 'none',
      }}
    >
      <Icon
        name="alert-triangle"
        size={16}
        style={{ color: 'var(--status-warn-fg)', flex: 'none', marginTop: 1 }}
      />
      <div>
        <div
          style={{
            fontSize: 12,
            fontWeight: 600,
            color: 'var(--status-warn-fg)',
            marginBottom: 2,
          }}
        >
          {t('drawer.returnBanner.title')}
        </div>
        <div style={{ fontSize: 13, color: 'var(--fg-1)' }}>{t('drawer.returnBanner.body')}</div>
      </div>
    </div>
  );
}
